<template>
	<div>
		<div>
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">回款计划管理</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row>

						<!-- 左侧组织架构 -->
						<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
							<Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
						</el-col>

						<!-- 右侧列表 -->
						<el-col :span="20">

							<el-row style="padding-left: 46px; padding-top: 40px;">
								<el-col :span="5">
									<span style="margin-left: 10px;">服务期</span>
									<el-date-picker v-model="condition.period_service" type="month" placeholder="选择服务期"
										value-format="yyyy-MM" style="margin-left:10px;width:150px">
									</el-date-picker>
								</el-col>

								<el-col :span="5">
									<span>金额</span>
									<el-input v-model="condition.estimate_collection_amount" style="margin-left:10px;width:150px"
										placeholder="请输入金额">
									</el-input>
								</el-col>

								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										查询</el-button>
								</el-col>
								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Add">
										新增</el-button>
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 50px;">
								<el-row>
									<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										height="540" tooltip-effect="dark" style="width: 100%;"
										@selection-change="handleSelectionChange">
										<el-table-column align="center" label="序号" width="50">
											<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
										</el-table-column>
										<el-table-column prop="projectName" align="center" label="项目名称">
										</el-table-column>
										<el-table-column prop="period_service" align="center" label="服务期"></el-table-column>
										<el-table-column prop="estimate_collection_date" align="center" label="预计回款时间">
										</el-table-column>
										<el-table-column prop="estimate_collection_amount" align="center" label="预计回款金额">
										</el-table-column>
										<el-table-column align="center" label="操作" width="100" fixed="right">
											<template slot-scope="scope">
												<img src="../../../assets/编辑.png" @click="Update(scope.row)">
												<img src="../../../assets/删除.png" @click="Del(scope.row.id)">
											</template>
										</el-table-column>
									</el-table>
								</el-row>
								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
										layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</el-row>

						</el-col>
					</el-row>

				</div>
			</el-row>
		</div>
		<el-dialog :title="ruleForm.id == null || ruleForm.id == '' ? '新增' : '修改'" :visible.sync="showDialog"
			width="30%" center="true" :close-on-click-modal="false">
			<div>
				<el-form label-position="right" label-width="100px" :model="formLabelAlign">
					<el-form-item label="项目名称">
						<el-input v-model="condition.project_name" placeholder=" " style="width: 100%;" disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="服务期">
						<el-date-picker v-model="ruleForm.period_service" type="month" placeholder="选择服务期"
							value-format="yyyy-MM" style="width: 100%;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计回款时间">
						<el-date-picker style="width: 100%;" v-model="ruleForm.estimate_collection_date" type="date"
							value-format="yyyy-MM-dd" placeholder="选择预计回款时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="预计回款金额">
						<el-input v-model="ruleForm.estimate_collection_amount" placeholder="请输入预计回款金额" style="width: 100%;">
						</el-input>
					</el-form-item>
					<div style="text-align:center">
						<el-button type="goon" @click="AddSave()" v-if="ruleForm.id == null || ruleForm.id == ''">保存</el-button>
						<el-button type="goon" @click="UpdateSave()" v-else>保存</el-button>
					</div>
					</el-button>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Structure from "../../utils/structure/structure.vue";

	import axios from "axios";
	export default {
		components: {
			Structure: Structure,
		},
		data() {
			return {
				//列表相关
				total: 0,
				tableData: [],

				//页面相关
				showDialog: false,

				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					project_id:'',
					period_service:'',
					estimate_collection_amount:'',
				},

				//详情
				ruleForm:{
					id:'',
					project_id:'',
					period_service:'',
					estimate_collection_date:'',
					estimate_collection_amount:'',
				},

				//复选框ids
				ids: [],
			};
		},
		methods: {
			Return() {
				this.dialogVisible = false;
				this.Find();
			},
			Add(){
				this.ruleForm = {};
				this.getProjectList();
				this.showDialog = true;
			},
			async AddSave(){
				this.ruleForm.project_id = this.condition.project_id;
				var data = await this.$globals.AxiosPost('AccountsCollectionPlan/add', this.ruleForm);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.ruleForm = {};
						this.showDialog = false;
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Update(e){
				this.ruleForm = e;
				this.showDialog = true
			},
			async UpdateSave(){
				this.ruleForm.project_id = this.condition.project_id;
				var data = await this.$globals.AxiosPost('AccountsCollectionPlan/update', this.ruleForm);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.ruleForm = {};
						this.showDialog = false;
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Del(e){
				var record = {
				    ids: [e],
				};
				var data = await this.$globals.AxiosPost('AccountsCollectionPlan/del', record);
				if (data === "-2000") {
				    this.$message.error("服务器未响应！请稍后重试");
				} else {
				    var code = data.code;
				    var data = data.data;
				    if (code === '200') {
				        this.$message.success(data);
				        this.Find();
				    } else {
				        this.$message.warning(data);
				    }
				}
			},
			//查询
			async Find() {
				var data = await this.$globals.AxiosPost('AccountsCollectionPlan/getList', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async getProjectList() {
				var res = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getProjectList', {});
				this.ProjectList = res.data
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val
				this.Find();
			},

		},
		async created() {
			this.Find();
		}
	}
</script>

<style scoped="scoped">
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
	}
	
	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		border-color: #05573d;
		color: #006e4b;
	}
	
	.el-button--goon {
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}
	
	.el-button--addbtn {
		color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}
	
	.el-table .warning-row {
		background: oldlace;
	}
	
	.el-table .success-row {
		background: #f0f9eb;
	}
	
	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}
	
	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}
	
	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}
	
	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}
	
	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// Collection.vue?42fcc0ec